import { createReducer } from 'deox';
import { Organisation } from '@/types';
import { fetchSiteMetadataActions } from '../actions';

export interface SiteMetadataState {
  organisation?: Organisation;
}

const initialState: SiteMetadataState = {
  organisation: undefined,
};

const siteMetadataReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchSiteMetadataActions.success, (_, { payload }) => ({
    ...payload.metadata,
  })),
]);

export default siteMetadataReducer;
